import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import axios from "axios";
import { Card, CardBody, Container, Row, Col } from "reactstrap";
import bgImage from "../../assets/images/COA-background.png";
import Signature from "../../assets/images/Signature-Image.png";
import EagleLogo from "../../assets/images/Eagle-logo (2).png";
import ais from "../../assets/images/AIS-logo.png";
import uk from "../../assets/images/Global-bureau.jpg";
import bqsr from "../../assets/images/Combined-logos.png";
import { QRCodeCanvas } from "qrcode.react";
import NeqasLogo from "../../assets/images/LogoNeqas.jpg";
import "../../assets/css/coa-certificate.scss";

class Certificate extends Component {
  constructor(props) {
    super(props);
    this.certificateRef = null;
    this.state = {
      participant_name: "",
      city: "",
      scheme_name: "",
      cycle_no: "",
      remaining_rounds: "",
      year: "",
      logo: "",
      sign: "",
      processedLogos: [],
      processedSignature: "",
      coa_status: "",
      account_id: "",
    };
  }

  componentDidMount() {
    const participant_id = this.props.match?.params?.id;
    const queryParams = new URLSearchParams(this.props.location.search);
    const scheme_id = queryParams.get("scheme_id");
    const cycle_id = queryParams.get("cycle_id");

    this.processAllLogos([ais, uk, bqsr]);
    this.makeTransparent(Signature, (transparentSignature) => {
      this.setState({ processedSignature: transparentSignature });
    });

    if (!participant_id || !scheme_id || !cycle_id) return;

    axios
      .get(
        `https://externalqcapi.com/api/lab/certificate/generate/${participant_id}/`,
        {
          params: {
            participant_id: participant_id,
            scheme_id: scheme_id,
            cycle_id: cycle_id,
          },
        },
      )
      .then((res) => {
        const data = res.data;
        this.setState({
          participant_name: data.participant_name || "",
          city: data.city || "",
          scheme_name: data.scheme_name || "",
          cycle_no: data.cycle_no || "",
          remaining_rounds: data.remaining_rounds || "",
          cycle_start_date: data.cycle_start_date || "",
          cycle_end_date: data.cycle_end_date || "",
          coa_status: data.coa_status || "",
          account_id:       data.account_id || "",
        });
      })
      .catch((err) => {
        console.error("Certificate API error:", err);
      });
  }

  makeTransparent = (imgSrc, callback) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imgSrc;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;
      for (let i = 0; i < data.length; i += 4) {
        if (data[i] > 240 && data[i + 1] > 240 && data[i + 2] > 240) {
          data[i + 3] = 0;
        }
      }
      ctx.putImageData(imageData, 0, 0);
      callback(canvas.toDataURL());
    };
  };

  processAllLogos = (logos) => {
    const processed = new Array(logos.length).fill(null);
    let completed = 0;
    logos.forEach((logo, index) => {
      this.makeTransparent(logo, (transparentSrc) => {
        processed[index] = transparentSrc;
        completed++;
        if (completed === logos.length) {
          this.setState({ processedLogos: processed });
        }
      });
    });
  };

  formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-4);
    return `${day} ${month} ${year}`;
  };

  formatYear = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    return date.getFullYear();
  };

  downloadPDF = async () => {
    if (!this.certificateRef) return;
    const html2canvas = (await import("html2canvas")).default;
    const { jsPDF } = await import("jspdf");
    const canvas = await html2canvas(this.certificateRef, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      foreignObjectRendering: false,
      imageTimeout: 15000,
      width: this.certificateRef.offsetWidth,
      height: this.certificateRef.offsetHeight,
      windowWidth: this.certificateRef.offsetWidth,
      windowHeight: this.certificateRef.offsetHeight,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape", "mm", "a4");
    const pageWidth = 297;
    const pageHeight = 210;
    const margin = 10;
    const imgWidth = pageWidth - margin * 2;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const topMargin = (pageHeight - imgHeight) / 2;
    pdf.setFillColor(43, 43, 43);
    pdf.rect(0, 0, pageWidth, pageHeight, "F");
    pdf.addImage(
      imgData,
      "PNG",
      margin,
      topMargin > 0 ? topMargin : margin,
      imgWidth,
      imgHeight,
    );
    pdf.save("certificate.pdf");
  };

  render() {
    const {
      participant_name,
      cycle_start_date,
      remaining_rounds,
      scheme_name,
      cycle_no,
      processedLogos,
      coa_status,
    } = this.state;

    // ✅ Read directly from URL — always available, never undefined
    const queryParams = new URLSearchParams(this.props.location.search);
    const scheme_id = queryParams.get("scheme_id");
    const cycle_id = queryParams.get("cycle_id");
    const account_id = this.state.account_id;

    const qrValue = `${window.location.origin}/${this.props.match.params.organization_name}/${this.props.match.params.id}/COA-verification?account_id=${account_id}&scheme_id=${scheme_id}&cycle_id=${cycle_id}`;

    return (
      <React.Fragment>
        <div className="page-content cert-page-content">
          <MetaTags>
            <title>Certificate</title>
          </MetaTags>

          <Container fluid>
            {coa_status === "Eligible" && (
              <div className="cert-download-row">
                <button
                  className="btn btn-secondary"
                  onClick={this.downloadPDF}
                >
                  Download PDF
                </button>
              </div>
            )}

            <Row className="justify-content-center">
              <Col className="cert-outer-col">
                {coa_status === "Eligible" ? (
                  <div
                    ref={(el) => (this.certificateRef = el)}
                    className="cert-capture-wrapper"
                  >
                    <Card
                      className="cert-card"
                      style={{ backgroundImage: `url(${bgImage})` }}
                    >
                      <CardBody className="cert-card-body">
                        <Row className="cert-full-height-row g-0">
                          <Col
                            md="12"
                            className="cert-content-col text-center d-flex flex-column"
                          >
                            {/* ── Logo + QR Area ── */}
                            <div className="cert-logo-area">
                              <img
                                src={NeqasLogo}
                                alt="NEQAS"
                                className="cert-neqas-logo"
                              />
                            </div>

                            <div className="cert-qr-wrapper">
                              {/* ✅ QR reads from URL directly */}
                              <QRCodeCanvas value={qrValue} size={90} />
                            </div>

                            <div className="cert-title">
                              CERTIFICATE OF ACHIEVEMENT
                            </div>

                            <Row className="justify-content-center">
                              <Col md="8">
                                <p className="cert-subtitle">
                                  NHS - National External Quality Assessment
                                  Scheme / Proficiency Testing
                                </p>
                              </Col>
                            </Row>

                            <h2 className="cert-participant-name fw-bold mt-4">
                              {participant_name || "-"}{" "}
                              {this.state.city ? `- ${this.state.city}` : ""}
                            </h2>

                            <div className="cert-divider" />

                            <p className="cert-completed-text">
                              Has Successfully completed Quality Assessment
                              Program
                            </p>

                            <h4 className="fw-bold">{scheme_name || "-"}</h4>

                            <p className="cert-cycle-text">
                              Cycle {cycle_no || "-"} ={" "}
                              {this.formatYear(cycle_start_date)}
                              {" | "}
                              Enrolled Rounds: {remaining_rounds ?? "-"}
                            </p>

                            <Row className="cert-bottom-row justify-content-center g-0 mt-auto">
                              <Col md="10" className="cert-bottom-col">
                                <div className="cert-logo-group">
                                  <div className="cert-acc-logo-1">
                                    <img
                                      src={processedLogos[0]}
                                      alt="logo-1"
                                      className="cert-acc-logo-img"
                                    />
                                  </div>
                                  <div className="cert-acc-logo-2">
                                    <img
                                      src={processedLogos[1]}
                                      alt="logo-2"
                                      className="cert-acc-logo-img"
                                    />
                                  </div>
                                  <div className="cert-acc-logo-3">
                                    <img
                                      src={processedLogos[2]}
                                      alt="logo-3"
                                      className="cert-acc-logo-img"
                                    />
                                  </div>
                                  <div className="cert-eagle-wrapper">
                                    <img
                                      src={EagleLogo}
                                      alt="Eagle Logo"
                                      className="cert-eagle-img"
                                    />
                                  </div>
                                </div>

                                <div className="cert-bottom-spacer" />

                                <div className="cert-signature-block">
                                  <div className="cert-signature-inner">
                                    <img
                                      src={
                                        this.state.processedSignature ||
                                        Signature
                                      }
                                      alt="signature"
                                      className="cert-signature-img"
                                    />
                                    <div className="cert-signature-line" />
                                  </div>
                                  <div className="cert-signature-text">
                                    <div>Director Scientific Affairs, NCQA</div>
                                    <div>NHS – NEQAS</div>
                                    <div>ASAB, NUST</div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  </div>
                ) : (
                  <div className="cert-not-available">
                    <h4 className="text-warning fw-bold">
                      ⚠️ Certificate Not Available
                    </h4>
                    <p className="text-muted mt-3">
                      Your COA certificate has not been issued for this cycle.
                      This may be due to incomplete participation or unmet
                      performance criteria.
                    </p>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Certificate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      organization_name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(Certificate);
